import { observer } from 'mobx-react-lite'
import { useJobDetailsViewModel } from '@/features/jobs/details/JobDetailsView'
import { PageLayout } from '@/features/jobs/details/components/PageLayout'
import { BillingSummarySectionContainer } from '@/features/jobs/details/components/BillingSummarySection'
import { JobScopeChangesSectionContainer } from '@/features/jobs/details/components/JobScopeChangesSection'
import { BillingContactSection } from '@/features/billing/components/BillingContactSection'
import { BillingPaymentHistorySectionContainer } from '@/features/jobs/details/components/BillingPaymentHistorySection'
import { useRootStore } from '@/contexts/root-store-context'

export const TaxJobBillingTab = observer(function TaxJobBillingTab() {
  const vm = useJobDetailsViewModel()
  const {
    shell: { shellInfo },
  } = useRootStore()

  return (
    <PageLayout
      asideTop={<BillingSummarySectionContainer vm={vm.jobBillingDetailsVm} />}
    >
      <JobScopeChangesSectionContainer vm={vm.jobScopeChangesDisplayVm} />

      <BillingPaymentHistorySectionContainer vm={vm.jobBillingDetailsVm} />

      {shellInfo.showTaxfyleInfo && <BillingContactSection />}
    </PageLayout>
  )
})
